"use strict";

import LocomotiveScroll from "locomotive-scroll";

const scroll = new LocomotiveScroll({
  el: document.querySelector("[data-scroll-container]"),
  smooth: true,
});

// MARQUEE
const init = () => {
  const marquee = document.querySelector('[wb-data="marquee"]');

  if (!marquee) {
    return;
  }
  const duration = parseInt(marquee.getAttribute("duration"), 10) || 5;
  const marqueeContent = document.querySelector(".marquee-content");
  if (!marqueeContent) {
    return;
  }

  const marqueeContentClone = marqueeContent.cloneNode(true);
  marquee.append(marqueeContentClone);

  let tween;

  const playMarquee = () => {
    let progress = tween ? tween.progress() : 0;
    tween && tween.progress(0).kill();
    const width = parseInt(
      getComputedStyle(marqueeContent).getPropertyValue("width"),
      10
    );

    const gap = parseInt(
      getComputedStyle(marqueeContent).getPropertyValue("column-gap"),
      10
    );

    const distanceToTranslate = -1 * (gap + width);

    tween = gsap.fromTo(
      marquee.children,
      { x: 0 },
      { x: distanceToTranslate, duration, ease: "none", repeat: -1 }
    );
    tween.progress(progress);
  };
  playMarquee();

  function debounce(func) {
    var timer;
    return function (e) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(
        () => {
          func();
        },
        500,
        e
      );
    };
  }

  window.addEventListener("resize", debounce(playMarquee));
};

const init2 = () => {
  const marquee = document.querySelector('[wb-data="marquee2"]');
  if (!marquee) {
    return;
  }
  const duration = parseInt(marquee.getAttribute("duration"), 10) || 5;
  const marqueeContent = document.querySelector(".marquee-content2");
  if (!marqueeContent) {
    return;
  }

  const marqueeContentClone = marqueeContent.cloneNode(true);
  marquee.append(marqueeContentClone);

  let tween;

  const playMarquee = () => {
    let progress = tween ? tween.progress() : 0;
    tween && tween.progress(0).kill();
    const width = parseInt(
      getComputedStyle(marqueeContent).getPropertyValue("width"),
      10
    );

    const gap = parseInt(
      getComputedStyle(marqueeContent).getPropertyValue("column-gap"),
      10
    );

    const distanceToTranslate = -1 * (gap + width);

    tween = gsap.fromTo(
      marquee.children,
      { x: 0 },
      { x: distanceToTranslate, duration, ease: "none", repeat: -1 }
    );
    tween.progress(progress);
  };
  playMarquee();

  function debounce(func) {
    var timer;
    return function (e) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(
        () => {
          func();
        },
        500,
        e
      );
    };
  }

  window.addEventListener("resize", debounce(playMarquee));
};

document.addEventListener("DOMContentLoaded", init);
document.addEventListener("DOMContentLoaded", init2);

// Cursor
const cursor = document.querySelector(".cursor");
const cursorInner = document.querySelector(".cursor_inner");
const links = document.querySelectorAll(".cursor_scale");

let mouseX;
let mouseY;

window.addEventListener("mousemove", (e) => {
  mouseX = e.clientX;
  mouseY = e.clientY;

  gsap.to(cursor, 0.5, { x: mouseX, y: mouseY, top: "-5px", left: "-5px" });
});

links.forEach((link) => {
  link.addEventListener("mouseenter", () => {
    cursorInner.style.transform = "scale(2)";
  });

  link.addEventListener("mouseleave", () => {
    cursorInner.style.transform = "none";
  });
});
